import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ObservableInput} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {ReplaySubject} from 'rxjs/ReplaySubject';

import {JwtService, ApiService} from '@common-lib';
import {User} from '../models';
import {map} from 'rxjs/operators/map';
import {distinctUntilChanged} from 'rxjs/operators/distinctUntilChanged';


@Injectable()
export class UserService {
    private currentUserSubject = new BehaviorSubject<User>({} as User);
    public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

    private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
    public isAuthenticated = this.isAuthenticatedSubject.asObservable();

    constructor(private apiService: ApiService,
                private http: HttpClient,
                private jwtService: JwtService) {


    }

    // Verify JWT in localstorage with server & load user's info.
    // This runs once on application startup.
    populate() {
        // If JWT detected, attempt to get & store user's info
        if (this.jwtService.getToken()) {
            const userData = this.jwtService.decodeToken();
            if (userData) {
                this.setAuth({...userData, token: this.jwtService.getToken()});
            } else {
                this.purgeAuth();
            }
        } else {
            // Remove any potential remnants of previous auth states
            this.purgeAuth();
        }
    }

    setAuth(user: User) {
        // Save JWT sent from server in localstorage
        this.jwtService.saveToken(user.token);
        // Set current user data into observable
        this.currentUserSubject.next(user);
        // Set isAuthenticated to true
        this.isAuthenticatedSubject.next(true);
    }

    purgeAuth() {
        // Remove JWT from localstorage
        this.jwtService.destroyToken();
        // Set current user to an empty object
        this.currentUserSubject.next({} as User);
        // Set auth status to false
        this.isAuthenticatedSubject.next(false);
    }

    attemptAuth(credentials): Observable<User> {
        const route = '/login';
        return this.apiService.post('/auth' + route, credentials)
            .pipe(map(
                data => {
                    this.setAuth(data.result);
                    return data.result;
                }
            ));
    }


    getCurrentUser(): User {
        return this.currentUserSubject.value;
    }


}



// WEBPACK FOOTER //
// ./src/app/core/services/user.service.ts